import React from "react";

export const DesignContext = React.createContext({});
